import { FC } from "react";
import clsx from "clsx";
import SafeHTML from "./SafeHTML";

type Props = {
    label: string;
    isRequired?: boolean
    className?: string
}

const LabelRequired: FC<Props> = ({ label, isRequired, className }) => {

    return (
      <span>
        <span className={clsx("text-lable-input", className)}>
          <SafeHTML content={label}/>
          {isRequired && <span className="color-red"> (*)</span>}
        </span>
      </span>
    )
};

export default LabelRequired
